import {Component, Event, EventEmitter, Fragment, h, Prop, State} from '@stencil/core';
import {
    getCountryList,
    getLanguageList,
    IApiResponse,
} from "./util";
import {addApiResponseChangeListener, getApiResponse} from "./api";


@Component({
    tag: 'dc-language-chooser-footer',
    styleUrl: '../../assets/styles/style.scss',
    shadow: true,
})
export class DcLanguageChooserFooter {
    @Prop() apiUrl: string;
    @Prop() countrySelectLabel: string;
    @Prop() languageSelectLabel: string;

    @State() apiResponse: IApiResponse | null = null;

    @Event({ eventName: 'countrySelect' }) countrySelectEvent: EventEmitter<{ label: string, value: string }>;


    async componentWillLoad() {
        const url = new URL(this.apiUrl);
        this.apiResponse = getApiResponse(url);
        addApiResponseChangeListener(url, newResponse => this.apiResponse = newResponse);
    }

    private onSelectChange(event: UIEvent): void {
        const label = (event.target as HTMLSelectElement).selectedOptions[0].label;
        const url = (event.target as HTMLSelectElement).value;

        this.countrySelectEvent.emit({
            label,
            value: url,
        });

        if (url) {
            setTimeout(() => window.location.assign(url));
        }
    }

    render() {
        // only render if an APIResponse exists
        if (!this.apiResponse) {
            return;
        }

        const countries = getCountryList(this.apiResponse);
        const languages = getLanguageList(this.apiResponse);

        return <Fragment>
            <div class="module-dropdown ">
                <div class="input-animation-wrapper">
                    <label htmlFor="location">{this.countrySelectLabel}</label>
                    <select
                        id="location"
                        class="custom-select location-select"
                        onChange={event => this.onSelectChange(event as UIEvent)}
                    >
                        {
                            countries.map(country => <option
                                selected={country.selected}
                                value={country.value}
                            >
                                {country.label}
                            </option>)
                        }
                    </select>
                    <div class="input-animation"></div>
                </div>
                <span class="error-message"></span>
            </div>
            <div class="module-dropdown ">
                <div class="input-animation-wrapper">
                    <label htmlFor="language">{this.languageSelectLabel}</label>
                    <select
                        id="language"
                        class="custom-select language-select"
                        onChange={event => this.onSelectChange(event as UIEvent)}
                    >
                        {
                            languages.map(lang => <option
                                selected={lang.selected}
                                value={lang.value}
                            >
                                {lang.label}
                            </option>)
                        }
                    </select>
                    <div class="input-animation"></div>
                </div>
                <span class="error-message"></span>
            </div>
        </Fragment>;
    }
}
